import type { StoreContext, WebShopProductListData } from '../../../app/data/model';
import { IEvent } from '../../../app/shared/EventAggregator';

export class WebShopProductListViewedEvent implements IEvent {
  constructor(
    public readonly storeContext: StoreContext,
    public readonly products: WebShopProductListData[],
  ) {}
}

export class WebShopProductSelectedEvent implements IEvent {
  constructor(
    public readonly storeContext: StoreContext,
    public readonly product: WebShopProductListData,
    public readonly index: number,
  ) {}
}
